import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IEnclosure, IEnclosureDocumentDetails } from '../../../shared/models/enclosure.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-zoom-controls-sld',
    templateUrl: './zoom-controls-sld.component.html',
    styleUrls: ['./zoom-controls-sld.component.scss'],
    standalone: false
})
export class ZoomControlsSldComponent {
  @Input() zoomLevel: number;
  @Input() enclosure: IEnclosure;
  @Output() zoomIn = new EventEmitter();
  @Output() zoomOut = new EventEmitter();
  @Output() zoomToFit = new EventEmitter();
  @Output() pdf = new EventEmitter<IEnclosureDocumentDetails>();

  zoomInGrid() {
    this.zoomIn.emit();
  }

  zoomOutGrid() {
    this.zoomOut.emit();
  }

  fitToWindow() {
    this.zoomToFit.emit();
  }

  generatePdf(title: string) {
    this.pdf.emit({ enclosure: this.enclosure, title});
  }

}
